import ReactDOM from 'react-dom'
import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {Provider} from 'react-redux'
import {store} from './redux/store'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
//import './_metronic/assets/css/style.rtl.css'
//import './_metronic/assets/sass/style.scss'
//import './_metronic/assets/sass/style.react.scss'

import {AppRoutes} from './app/routing/AppRoutes'
import {setupAxios} from './redux/setup-axios'
import 'react-notifications-component/dist/theme.css'
import {ReactNotifications} from 'react-notifications-component'
import {I18nProvider} from './_metronic/i18n/i18nProvider'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

Chart.register(...registerables)

const container = document.getElementById('root')!
const root = createRoot(container) // createRoot(container!) if you use TypeScript


root.render(
  <>
    <ReactNotifications />
    <MetronicI18nProvider>
      <I18nProvider>
        <Provider store={store}>
          <AppRoutes />
        </Provider>
      </I18nProvider>
    </MetronicI18nProvider>
  </>
)

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', {updateViaCache: 'none'})
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[ServiceWorker] registration failed:', error)
        }
      })
  })
}